import * as React from 'react';
import S from './TabList.styles';
const TabList = (props) => {
    return (React.createElement(S.Container, null, props.items.map((item) => (React.createElement(S.Item, { key: item.id, "data-active": props.value === item.id },
        React.createElement(S.Button, { onClick: (event) => {
                event.preventDefault();
                props.onChange(item.id);
            } },
            props.showMonthly && React.createElement("span", null, item.subtitle),
            React.createElement("span", null, item.title)))))));
};
export default TabList;
